import { twMerge } from 'tailwind-merge'

type Props = {
  label?: string
} & ((React.ComponentPropsWithoutRef<'div'>))

export function Divider({ className, label }: Props) {
  className = twMerge('relative', className)

  return (
    <div className={className}>
      <div className='absolute inset-0 flex items-center'>
        <div className='w-full border-t' />
      </div>
      {
        label &&
        <div className='relative flex justify-center'>
          <span className='bg-white dark:bg-zinc-900 font-light px-4 text-sm/6 text-zinc-500 font-mono'>{label}</span>
        </div>
      }
    </div>
  )
}

